import React, { FC } from 'react';
import styled from 'styled-components';

import { CopyInput } from './CopyInput';

export interface InlineCopyInputProps {
  label: string;
  value: string;
  isMonospaced?: boolean;
  minWidth?: string;
}

const StyledCopyInput = styled(CopyInput)`
  border-radius: 6px;
  --input-border-color: transparent;
  padding: 6px 8px;

  &:hover {
    --input-background: ${({ theme }) => theme.style.inputDefaultBackgroundColor};
    --input-border-color: ${({ theme }) => theme.style.inputDefaultHoveredBorderColor};
  }
`;

const Wrapper = styled.div<{ $minWidth?: string }>`
  border-radius: 8px;
  padding: 2px 2px 2px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 0 0 1px ${({ theme }) => theme.secondary.blendToBackground(200)};
  ${({ $minWidth }) => $minWidth && `min-width: ${$minWidth};`}
  box-sizing: border-box;

  &:hover ${StyledCopyInput} {
    --input-background: ${({ theme }) => theme.style.inputDefaultBackgroundColor};
    --input-border-color: transparent;
  }
`;

const Label = styled.label<{ size?: 'small' | 'default' }>`
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.foreground};
`;

export const InlineCopyInput: FC<InlineCopyInputProps> = ({ label, value, isMonospaced = false, minWidth }) => {
  return (
    <Wrapper $minWidth={minWidth}>
      <Label>{label}</Label>
      <StyledCopyInput value={value} isMonospaced={isMonospaced} fullWidth />
    </Wrapper>
  );
};
